
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/kitchen-design-app",
      function () {
        return require("private-next-pages/kitchen-design-app.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/kitchen-design-app"])
      });
    }
  